const Languages = {
    Polish: 1,
    English: 2,
    Russian: 3,
    Czech: 4,
    Ukrainian: 5,
    Romanian: 6,
    Bulgarian: 7,
    Slovakian: 8,
    Hungarian: 9,
    German: 10,
    Spanish: 11,
    French: 12,
    Italian: 13,
    Dutch: 14,
    Arabic: 15,
    Hebrew: 16,
    Portuguese: 17,
    Turkish: 18,
    Finnish: 19,
    Serbian: 20,
    Croatian: 21,
    Swedish: 22,
    Chinese: 23
};
export const LanguageCodes = {
    1: 'pl', // polski
    2: 'en', // angielski
    3: 'ru', // rosyjski
    4: 'cz', // czeski
    5: 'ua', // ukrainski
    6: 'ro', // rumunski
    7: 'bg', // bułgarski
    8: 'sk', // słowacki
    9: 'hu', // wegierski
    10: 'de', // niemiecki
    11: 'es', // hiszpanski
    12: 'fr', // francuski
    13: 'it', // włoski
    14: 'nl', // holenderski
    15: 'ar', // arabski
    16: 'he', // hebrajski
    17: 'pt', // portugalski
    18: 'tr', // turecki
    19: 'fi', // finski
    20: 'sr', // serbski
    21: 'hr', // chorwacki
    22: 'sv', // szwedzki
    23: 'cn', // chiński
};
export default Languages;